import { RESOLVE_TO } from '../constants'
import { isPinningAnchorType } from '../hooks/anchorConstraints'
import { resolvePinningFromAnchor } from './locks'

export const validateCompoundAnchors = (schedule, scheduleIndex, entityLookup) => {
  const errors = {}
  if (!schedule?.combineAnchors) return errors
  const prefix = `schedules.${scheduleIndex}`
  if (!Object.values(RESOLVE_TO).includes(schedule.resolveTo)) {
    errors[`${prefix}.resolveTo`] = 'Select Earliest Of or Latest Of.'
  }
  if ((schedule.anchors || []).length < 2) {
    errors[`${prefix}.anchors`] = 'Combined anchors require at least two independently configured anchors.'
  }

  const pinning = (schedule.anchors || [])
    .map((anchor, index) => ({
      index,
      pinning: resolvePinningFromAnchor(anchor, entityLookup),
    }))
    .filter(item => item.pinning && isPinningAnchorType(schedule.anchors[item.index].type))

  if (pinning.length < 2) return errors

  const first = pinning[0].pinning
  const conflict = pinning.find(
    item =>
      (first.armId && item.pinning.armId && first.armId !== item.pinning.armId) ||
      (first.phaseId && item.pinning.phaseId && first.phaseId !== item.pinning.phaseId),
  )
  if (conflict) {
    const names = pinning
      .map(item => `Anchor ${item.index + 1} (Arm ${item.pinning.armId || '—'}, Phase ${item.pinning.phaseId || '—'})`)
      .join('; ')
    errors[`${prefix}.compoundPin`] =
      `Combined anchors pin different Arms and/or Phases. There is no default winner. Conflicting anchors: ${names}`
  }
  return errors
}

/**
 * Offsets apply to each anchor first, then Earliest/Latest compares those resolved dates.
 * Example: Cycle 3 Start Day 100 + 1 vs EOT Day 105 → Latest Of is 105, not 106.
 */
export const resolveCombinedDate = (resolvedDates, resolveTo) => {
  const values = (resolvedDates || []).filter(value => value != null && !Number.isNaN(value))
  if (!values.length) return null
  if (resolveTo === RESOLVE_TO.earliestOf) return Math.min(...values)
  return Math.max(...values)
}
